import { useMemo } from 'react';

import { ReferenceContextContainer } from 'src/components/contexts/ReferenceContext/ReferenceContextContainer';
import { CustomersPage } from 'src/pages/CustomersPage';
import { NotFoundPage } from 'src/pages/NotFoundPage';
import { VendorsPage } from 'src/pages/VendorsPage';
import { VendorLeadBillingInfoPage } from 'src/pages/VendorsPage/VendorLeadBillingInfoPage';

function parsePathname(pathname: string): string[] {
  return (pathname.startsWith('/') ? pathname.substring(1) : pathname).split('/');
}

// Do not work after history.pushState
function useLocationInfo() {
  const pathParams = useMemo(() => parsePathname(window.location.pathname), []);

  const isCustomersPage = useMemo(() => pathParams.length === 2 && pathParams[0] === 'customers', [pathParams]);

  const isVendorsPage = useMemo(() => pathParams.length === 2 && pathParams[0] === 'vendors', [pathParams]);
  const isVendorsBillingInfoPage = useMemo(
    () => pathParams.length === 3 && pathParams[0] === 'vendors' && pathParams[2] === 'billing',
    [pathParams]
  );

  return {
    pathParams,

    isCustomersPage,
    isVendorsPage,
    isVendorsBillingInfoPage,
  };
}

export function Routes() {
  const { pathParams, isVendorsPage, isVendorsBillingInfoPage, isCustomersPage } = useLocationInfo();

  return (
    <ReferenceContextContainer>
      {isVendorsPage ? (
        <VendorsPage vendorProductLeadId={pathParams[1]} />
      ) : isVendorsBillingInfoPage ? (
        <VendorLeadBillingInfoPage vendorLocationId={pathParams[1]} />
      ) : isCustomersPage ? (
        <CustomersPage customerProductLeadId={pathParams[1]} />
      ) : (
        <NotFoundPage />
      )}
    </ReferenceContextContainer>
  );
}
